import service from '@/store/services/company-service';
import axios from 'axios';

const state = {
  companySummary: null,
  currentId: null,
  companyList: null,
  searchList: null,
};

const mutations = {
  SET_COMPANY_SUMMARY: (state, companySummary) => {
    state.companySummary = companySummary;
  },
  SET_CURRENT_ID: (state, currentId) => {
    state.currentId = currentId;
  },
  SET_COMPANY_LIST: (state, companyList) => {
    state.companyList = companyList;
  },
  SET_SEARCH_LIST: (state, searchList) => {
    state.searchList = searchList;
  },
};

const getters = {
  companySummary: (state) => state.companySummary,
  currentId: (state) => state.currentId,
  companyList: (state) => state.companyList,
  searchList: (state) => state.searchList,
};

const actions = {
  search({ commit, dispatch, state }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    params.session_id = currentSession;

    return service
      .search(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
            'Server responded with error = True <br> errorCode: ' +
            res.data.errorCode,
            { root: true }
          );
        }
        commit('SET_SEARCH_LIST', res.data.list);
        return res.data.list;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  createProfile({ commit, dispatch, state }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    params.session_id = currentSession;

    return service
      .createProfile(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          if (res.data.errorCode === 'no_data_available') {
            commit('SET_ERROR_BIT', true, { root: true });
            commit(
              'SET_ERROR_INFO',
              res.data.errorCode,
              { root: true }
            );
          }
          else {
            commit('SET_ERROR_BIT', true, { root: true });
            commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
              { root: true }
            );
          }
        }
        // commit('SET_SEARCH_LIST', res.data.list);
        return res.data;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        // For soft "error: true" responses the interceptor already committed a formatted
        // errorInfo carrying the API errorCode -- don't clobber it with a stack trace
        // that has no code in it (and, in Firefox/Safari, no message either). Without
        // this guard the "no data for this company" dialog can never match.
        if (!err.softApiError) {
          commit('SET_ERROR_INFO', err.stack, { root: true });
        }
      });
  },
  favoriteCompany({ commit, dispatch, state }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    params.session_id = currentSession;

    return service
      .favoriteCompany(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
            'Server responded with error = True <br> errorCode: ' +
            res.data.errorCode,
            { root: true }
          );
        }
        // commit('SET_SEARCH_LIST', res.data.list);
        return res.data;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  unfavoriteCompany({ commit, dispatch, state }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    params.session_id = currentSession;

    return service
      .unfavoriteCompany(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
            'Server responded with error = True <br> errorCode: ' +
            res.data.errorCode,
            { root: true }
          );
        }
        // commit('SET_SEARCH_LIST', res.data.list);
        return res.data;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
  favorites({ commit, dispatch, state }, params) {
    let currentSession = localStorage.getItem(
      'vue-authenticate.vueauth_access_token'
    );
    params.session_id = currentSession;

    return service
      .favorites(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
            'Server responded with error = True <br> errorCode: ' +
            res.data.errorCode,
            { root: true }
          );
        }
        // commit('SET_SEARCH_LIST', res.data.list);
        return res.data;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
};

const companyList = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default companyList;
